const folderDefaultState = {
  folders: [],
  folderDepth: null,
  breadcrumbsMultipleLevelsArray: [], // for general use later, pls move this state somewhere else
  currentFolderDepth: 0,
  currentFolderPermission: [],
  parentFolderHasShared: false,
  currentFolder: null,
}

export default folderDefaultState
